import React, { Component } from "react";

import { Redirect } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import QrReader from "react-qr-reader";

import Button from "../../components/standard/Button";
import InputField from "../../components/standard/InputField";
import Error from "../../components/standard/Error/Error";

import "./TableCode.css";

import { loginRequest } from "../../services/APICall";

class TableCode extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: "",
      delay: 500,
      result: "No result",
      username: null,
      password: null,
    };

    if (localStorage.getItem("username")) {
      window.location.pathname = "/scan";
    }

    this.desktop = false;

    if (window.screen.width > 600) {
      this.desktop = true;
    }
  }

  makeLoginRequest() {
    loginRequest(
      "/api/v1/voucher/login",
      this.state.username,
      this.state.password
    )
      .then((response) => {
        if (response.status === 200) {
          localStorage.setItem("username", this.state.username);
          localStorage.setItem("password", this.state.password);
          window.location.pathname = "/scan";
        } else {
          alert("Invalid credentials");
        }
      })
      .catch((error) => {
        alert("Some error occurred");
        Promise.reject("Some error occurred");
      });
  }

  handleError(err) {
    console.error(err);
  }

  // Key event handler to sync data between input component and scree.
  handleusernameChange = (e) => {
    var text = e.target.value;

    this.setState({ username: text });
  };

  // Key event handler to sync data between input component and scree.
  handlePasswordchage = (e) => {
    var text = e.target.value;

    this.setState({ password: text });
  };

  render() {
    // Redirect to menu after valid table code
    if (this.state.redirect) {
      return <Redirect push to={"/menu/" + this.state.table_id} />;
    }

    if (this.desktop) {
      return (
        <div className="desktop-table-code">
          <img
            src={
              "https://cdn-imgix-open.headout.com/logo/svg/Headout_logo_purps.svg?w=300&h=50&fit=fill"
            }
            alt="Headout's logo"
            className="headout-logo"
          />

          <div className="desktop-text">Ticket scanning app</div>

          <InputField
            type="text"
            placeholder="Username"
            value={this.state.username}
            onChangeValue={this.handleusernameChange}
            style="text-transform: uppercase"
          />

          <br />
          <InputField
            type="password"
            placeholder="Enter  password"
            value={this.state.password}
            onChangeValue={this.handlePasswordchage}
            style="text-transform: uppercase"
            W
          />
          <br />
          <Button
            align="center"
            color="Purps"
            text="Login"
            type="non-network"
            onClickEvent={this.makeLoginRequest.bind(this)}
            border
          />
        </div>
      );
    }

    return (
      <div className="Table-code">
        <div className="Top-bar">
          <div className="Background"></div>
          <div className="Topbar-content">
            <div className="Logo-section">
              <div className="Sveet-logo">
                <img
                  src={
                    "https://cdn-imgix-open.headout.com/logo/svg/Headout_logo_purps.svg?w=300&h=50&fit=fill"
                  }
                  className="headout-logo"
                  alt="Headout's logo"
                />
              </div>
              <div className="Logo-text">Ticket scanning app</div>
            </div>
          </div>
        </div>
        <div className="Action-container">
          <div
            className={"Enter-OTP" + (this.state.error ? " Error-Input" : "")}
          >
            <InputField
              type="text"
              placeholder="Username"
              value={this.state.username}
              onChangeValue={this.handleusernameChange}
              style="text-transform: uppercase"
              W
            />

            <br></br>
            <InputField
              type="password"
              placeholder="Enter  password"
              value={this.state.password}
              onChangeValue={this.handlePasswordchage}
              style="text-transform: uppercase"
              W
            />
          </div>

          <div className="Next-button">
            <Button
              align="center"
              color="Purps"
              text="Login"
              type="non-network"
              onClickEvent={this.makeLoginRequest.bind(this)}
              border
            />
          </div>
        </div>
      </div>
    );
  }
}

// Connects this state and App.jsx redux calls and data passing
export default TableCode;



// WEBPACK FOOTER //
// ./src/screens/TableCode/Login.jsx